import React from 'react';

const Badge = ({ backgroundColor = '#7ec5c6', number, textColor = '#153c4f', style }) => {
	const text = number > 99 ? '99+' : number;
	return (
		<div
			style={{
				position: 'absolute',
				minWidth: 17,
				minHeight: 17,
				padding: '4px',
				backgroundColor,
				borderRadius: 100,
				zIndex: 2,
				marginLeft: 20,
				alignItems: 'center',
				justifyContent: 'center',
				top: -10,
				right: -10,
				color: textColor,
				textAlign: 'center',
				...style,
			}}
		>
			<div>{text}</div>
		</div>
	);
};
export default Badge;
